import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toParagraph',
  standalone: true,
})
export class ToParagraphPipe implements PipeTransform {
  constructor() {}

  transform(text: string): string {
    if (text) {
      return this.toParagraph(text);
    }
    return text;
  }

  toParagraph(value: string): string {
    value = value.replace(/\s+/g, ' ');
    value = value.replace(/(\\r\\n|\\r|\\n)/g, '');
    // Capitalize the first letter of each sentence
    value = value.replace(/(^\w|\.\s*\w)/g, (match) => match.toUpperCase());
    // Add space after commas (remove extra spaces)
    value = value.replace(/\s*,\s*/g, ', ');
    return value;
  }

  /*toParagraph(value: string): string {
    value = this.toFirstUpperCaseLetter(value);
    return value.replace(/([!?.]\s+)([a-z])/g, (m, $1, $2) => {
      return $1 + $2?.toUpperCase();
    });
  }

  toFirstUpperCaseLetter(value: string): string {
    return value?.charAt(0)?.toUpperCase() + value?.slice(1);
  }*/
}
